import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import {ApiFile} from './File';

export enum ProviderStatus {
  Interessenten = '1',
  Kunden = '2',
  EhemaligeKunden = '3',
  InteressentErledigt = '6',
  Lieferanten = '9',
}

export interface ApiOutgoingPostAddress {
  Briefanrede: string;
  Name1: string;
  Name2: string;
  Name3: string;
  Strasse: string;
  NAT: string;
  Plz: string;
  Ort: string;
  Postfach: string | null,
  PostfachPlz: string | null,
  PostfachOrt: string | null,
  Telefon1: string;
  Telefon2: string;
  Telefax: string;
  Email: string;
  Homepage: string;
  KundenNr?: number;
  Frei1: null;
  Frei2: null;
  Frei3: null;
  Frei4: null;
  LangName1: string;
  LangName2: string;
  LangName3: string;
}

export interface ApiPostAddress extends ApiOutgoingPostAddress {
  Art: string;
  Number: number;
}

export interface ApiProvider {
  PostAnschrift?: ApiPostAddress[]
  Dateien?: {
    Values: [ApiFile]
  },
  Unterlagen?: {
    Values: [
      {
        Seiten: [
          {
            Seite: number,
            DownloadToken: string,
          }
        ],
        Bezeichnung: string,
        Dateiname: string | null,
        AngelegtAm: string,
        Bediener: string,
      }
    ]
  }
  KundenNr: number;
  ErstellDatum: string;
  Niederlassung: number;
  Kostenstelle: number;
  Kundname: string;
  KundStatus: string;
  LieferantErledigt: boolean;
  Staat: string;
  DebitorKto: number;
  KreditorKto: number;
}

export interface ApiInteressentSubmitData {
  ErstellDatum: string,
  Kundname: string,
  Staat: string | null,
  Gebiet: string | null,
  // StatusABC: string | null,
  // Umsatz: number | null,
  BetriebsNr: string | null,
  UStId: string | null,
  Steuernummer: string | null,
  // FaxSperre: string,
  // Sperre: string | null,
  // HauptKonto: number | null,
  // KundenGruppe: number | null,
  // Bundesland: number | null,
  ZahlungsBedingungen?: {
    SkontoTage1: number | null,
    SkontoProzent1: number | null,
    SkontoTage2: number | null,
    SkontoProzent2: number | null,
    NettoTage: number | null,
    Text: string,
  },
  PostAnschrift: ApiOutgoingPostAddress[],
  RechnungAnschrift?: ApiOutgoingPostAddress[],
}

export interface DetailProviderFilters {
  KundenNr?: number;
}

export interface ProviderFilters {
  KundStatus$In?: ProviderStatus[];
  KundenNr?: number;
  Kundname?: string;
  LieferantErledigt?: boolean;
  Fulltext$Fulltext: FulltextSearch;
}

export default class Provider extends autoImplement<ApiProvider>() {
  static fromApi(apiProvider: ApiProvider): Provider {
    return new Provider(apiProvider);
  }

  get GroupName() {
    switch (this.KundStatus) {
      case ProviderStatus.EhemaligeKunden:
        return 'Ehemalige Kunde';
      case ProviderStatus.Interessenten:
        return 'Interessent';
      case ProviderStatus.Lieferanten:
        return 'Lieferant';
      case ProviderStatus.InteressentErledigt:
        return 'erl. Interessent';
      default:
        return 'Kunde';
    }
  }
  get color() {
    switch (this.KundStatus) {
      case ProviderStatus.EhemaligeKunden:
        return 'error';
      case ProviderStatus.Interessenten:
        return 'warning';
      case ProviderStatus.Lieferanten:
        return 'info';
      case ProviderStatus.Kunden:
        return 'success';
      case ProviderStatus.InteressentErledigt:
        return '#840000';
      default:
        return 'dark';
    }
  }
  get icon() {
    switch (this.KundStatus) {
      case ProviderStatus.EhemaligeKunden:
        return 'mdi-cancel';
      case ProviderStatus.Interessenten:
        return 'mdi-account-star';
      case ProviderStatus.Lieferanten:
        return 'mdi-truck-delivery';
      case ProviderStatus.Kunden:
        return 'mdi-account';
      case ProviderStatus.InteressentErledigt:
        return 'mdi-cancel';
      default:
        return 'mdi-account';
    }
  }
}
